import React from 'react'

function StaffManagementFeatureBox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage2.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Staff Management System</span>
                        <h2>Smart Workforce & Employee Control Platform</h2>
                        <p>Streamline your entire workforce management process with a powerful and modern Staff Management system. Manage employees, track attendance, and monitor performance all in one digital platform designed for speed, accuracy, and efficiency.</p>
                        <h5>Powerful Features for Better Productivity</h5>
                        <ul>
                            <li>Add / create staff sub-user accounts</li>
                            <li>Assign username & temporary password</li>
                            <li>Assign staff to specific locations</li>
                            <li>View staff activity in transaction history</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StaffManagementFeatureBox1